// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.envio-sms-page[data-v-52eb9459] {
  --ink: #1b2740;
  --ink-soft: #5c6b86;
  --line: #d5deea;
  --sheet: #f3f6fa;
  --field: #8b97ab;
  --binding: #ff7900;
  --seguimiento: #c2410c;
  --cierre: #0f6e6a;
  --emergencia: #9b1c3c;
  margin-top: -0.75rem;
  padding-top: 0.65rem;
  background: #fff;
  color: var(--ink);
}
.envio-sms-formulario[data-v-52eb9459] {
  max-width: none;
  margin-left: auto;
  margin-right: auto;
}
.envio-sms-sheet[data-v-52eb9459] {
  background: var(--sheet);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 0.8rem 1rem 0.7rem;
}
.envio-sms-cabecera[data-v-52eb9459] {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  margin-bottom: 0.6rem;
}
.envio-sms-origen[data-v-52eb9459] {
  flex: 0 1 16rem;
  width: 16rem;
  margin-bottom: 0;
}
.envio-sms-clave[data-v-52eb9459] {
  margin-bottom: 0.6rem;
}
.envio-sms-mando[data-v-52eb9459] {
  display: grid;
  grid-template-columns: minmax(12rem, 0.9fr) minmax(18rem, 1.35fr) auto;
  gap: 0.55rem 1rem;
  align-items: end;
}
.envio-sms-datos[data-v-52eb9459],
.envio-sms-grid-4[data-v-52eb9459] {
  display: grid;
  gap: 0.55rem 0.85rem;
  margin-top: 0.65rem;
}
.envio-sms-datos[data-v-52eb9459] {
  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1.25fr) 11.5rem 9.5rem;
}
.envio-sms-grid-4[data-v-52eb9459] {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.envio-sms-acciones[data-v-52eb9459] {
  grid-column: 1 / -1;
}
.envio-sms-formulario #seccionCabecera p[data-v-52eb9459] {
  text-align: left;
  padding-left: 0;
  margin-bottom: 0;
}
.envio-sms-title[data-v-52eb9459] {
  display: block;
  font-size: 1.45rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--ink);
}
.envio-sms-title[data-v-52eb9459]::after {
  content: "";
  display: block;
  width: 2.25rem;
  height: 3px;
  margin-top: 0.35rem;
  background: var(--binding);
}
.envio-sms-lead[data-v-52eb9459] {
  margin-top: 0.55rem;
  color: var(--ink-soft);
  font-size: 0.95rem;
}
.envio-sms-secuencia[data-v-52eb9459] {
  border: 0;
  margin: 0;
  padding: 0;
  min-inline-size: 0;
}
.envio-sms-bloque-titulo[data-v-52eb9459] {
  margin: 0 0 0.7rem;
  padding: 0;
  float: none;
  width: auto;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--ink);
}
.envio-sms-bloque[data-v-52eb9459] {
  margin-top: 1.45rem;
}
.envio-sms-bloque-primero[data-v-52eb9459] {
  margin-top: 0.15rem;
}
.envio-sms-fin[data-v-52eb9459] {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.45rem 1rem;
  margin-top: 0.6rem;
}
.envio-sms-bloque-lead[data-v-52eb9459] {
  margin: -0.35rem 0 0.8rem;
  color: var(--ink-soft);
  font-size: 0.84rem;
  line-height: 1.4;
}
.envio-sms-secuencia-grid[data-v-52eb9459] {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.4rem;
}
.envio-sms-placa[data-v-52eb9459] {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  min-height: calc(1.5em + 0.56rem + 2px);
  margin: 0;
  padding: 0 0.65rem;
  border: 1px solid var(--line);
  border-left: 4px solid var(--ink);
  border-radius: 6px;
  background: #fff;
  color: var(--ink);
  cursor: pointer;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
}
.envio-sms-placa--seguimiento[data-v-52eb9459] {
  border-left-color: var(--seguimiento);
}
.envio-sms-placa--cierre[data-v-52eb9459],
.envio-sms-placa--final[data-v-52eb9459] {
  border-left-color: var(--cierre);
}
.envio-sms-placa input[data-v-52eb9459] {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
.envio-sms-placa-name[data-v-52eb9459] {
  font-size: 0.92rem;
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.envio-sms-placa-hint[data-v-52eb9459] {
  color: var(--ink-soft);
  font-size: 0.82rem;
  line-height: 1.3;
}
.envio-sms-placa[data-v-52eb9459]:hover:not(.is-selected, .is-disabled) {
  background: #f4f7fb;
}
.envio-sms-placa.is-disabled[data-v-52eb9459],
.envio-sms-placa.is-disabled[data-v-52eb9459]:hover {
  background: #f3f5f8;
  color: var(--ink-soft);
  cursor: not-allowed;
}
.envio-sms-placa.is-disabled input[data-v-52eb9459] {
  cursor: not-allowed;
}
.envio-sms-apertura-nota[data-v-52eb9459] {
  margin-top: 0.55rem;
}
.envio-sms-placa[data-v-52eb9459]:focus-within {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}
.envio-sms-placa.is-selected[data-v-52eb9459] {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}
.envio-sms-placa--seguimiento.is-selected[data-v-52eb9459] {
  background: var(--seguimiento);
  border-color: var(--seguimiento);
}
.envio-sms-placa--cierre.is-selected[data-v-52eb9459],
.envio-sms-placa--final.is-selected[data-v-52eb9459] {
  background: var(--cierre);
  border-color: var(--cierre);
}
.envio-sms-placa.is-selected .envio-sms-placa-hint[data-v-52eb9459] {
  color: rgba(255, 255, 255, 0.84);
}
.envio-sms-secuencia.is-invalid .envio-sms-placa[data-v-52eb9459]:not(.is-selected) {
  border-color: var(--emergencia);
  background: #fde8ec;
}
.envio-sms-clasificacion[data-v-52eb9459] {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem 1.75rem;
  margin-top: 0.9rem;
}
.envio-sms-estado[data-v-52eb9459] {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.35;
}
.envio-sms-severidad[data-v-52eb9459] {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem;
}
.envio-sms-severidad-label[data-v-52eb9459] {
  flex: 1 0 100%;
  margin: 0 0 0.3rem;
  padding: 0;
  float: none;
  width: auto;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.2;
}
.envio-sms-chip[data-v-52eb9459] {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin: 0;
  min-height: calc(1.5em + 0.56rem + 2px);
  padding: 0 0.8rem;
  border: 1px solid var(--field);
  border-radius: 4px;
  background: #fff;
  color: var(--ink);
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
}
.envio-sms-chip input[data-v-52eb9459] {
  position: absolute;
  inset: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
.envio-sms-chip[data-v-52eb9459]:focus-within {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}
.envio-sms-chip.is-selected[data-v-52eb9459] {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}
.envio-sms-chip--emergencia.is-selected[data-v-52eb9459] {
  background: var(--emergencia);
  border-color: var(--emergencia);
}
.envio-sms-chip[data-v-52eb9459]:has(input.is-invalid):not(.is-selected) {
  border-color: var(--emergencia);
  background: #fde8ec;
}
.envio-sms-id-row[data-v-52eb9459],
.envio-sms-grid-3[data-v-52eb9459],
.envio-sms-destino[data-v-52eb9459] {
  display: grid;
  gap: 0.75rem 1rem;
}
.envio-sms-id-row[data-v-52eb9459] {
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);
}
.envio-sms-grid-3[data-v-52eb9459] {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 0.65rem;
}
.envio-sms-destino[data-v-52eb9459] {
  grid-template-columns: repeat(auto-fit, minmax(16rem, 22rem));
}
.envio-sms-cuando[data-v-52eb9459],
.envio-sms-fin-cuando[data-v-52eb9459] {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem 1rem;
}
.envio-sms-cuando[data-v-52eb9459] {
  margin-top: 0.75rem;
}
.envio-sms-field-gap[data-v-52eb9459] {
  margin-top: 0.75rem;
}
.envio-sms-gestor[data-v-52eb9459] {
  flex: 1 1 16rem;
  min-width: 12rem;
}
.envio-sms-field[data-v-52eb9459] {
  margin-bottom: 0;
}
.envio-sms-formulario[data-v-52eb9459] .form-label {
  margin-bottom: 0.3rem;
  color: var(--ink);
  font-size: 0.82rem;
  font-weight: 600;
}
.envio-sms-mark[data-v-52eb9459] {
  margin-left: 0.35rem;
  color: var(--ink-soft);
  font-size: 0.75rem;
  font-weight: 400;
}
.envio-sms-req[data-v-52eb9459] {
  margin-left: 0.15rem;
  color: var(--binding);
  font-weight: 700;
}
.envio-sms-hint[data-v-52eb9459] {
  margin: 0.35rem 0 0;
  color: var(--ink-soft);
  font-size: 0.8rem;
  line-height: 1.35;
}
.envio-sms-fin-check[data-v-52eb9459] {
  margin-top: 0.1rem;
}
.envio-sms-fin-cuando[data-v-52eb9459] {
  margin-top: 0.75rem;
}
.envio-sms-field-fecha[data-v-52eb9459],
.envio-sms-field-hora[data-v-52eb9459] {
  flex: 0 0 auto;
}
.envio-sms-field-fecha[data-v-52eb9459] .form-control {
  width: 11.2rem;
  max-width: 100%;
}
.envio-sms-field-hora[data-v-52eb9459] .form-control {
  width: 8.2rem;
  max-width: 100%;
}
.envio-sms-formulario[data-v-52eb9459] .form-control,
.envio-sms-formulario[data-v-52eb9459] .form-select {
  border-color: var(--field);
  border-radius: 4px;
  color: var(--ink);
  padding-top: 0.28rem;
  padding-bottom: 0.28rem;
  min-height: calc(1.5em + 0.56rem + 2px);
}
.envio-sms-formulario[data-v-52eb9459] textarea.form-control {
  min-height: 0;
}
.envio-sms-formulario[data-v-52eb9459] .form-control:focus,
.envio-sms-formulario[data-v-52eb9459] .form-select:focus {
  border-color: var(--ink);
  box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);
}
.envio-sms-formulario[data-v-52eb9459] .form-control.is-invalid,
.envio-sms-formulario[data-v-52eb9459] .form-select.is-invalid,
.envio-sms-formulario[data-v-52eb9459] textarea.is-invalid {
  border-color: var(--emergencia);
  background-color: #fde8ec;
}
.envio-sms-resizable[data-v-52eb9459] {
  resize: vertical;
  overflow-y: auto;
}
.envio-sms-footer[data-v-52eb9459] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.7rem;
  padding-top: 0.6rem;
  border-top: 1px solid var(--line);
}
.envio-sms-footer-status[data-v-52eb9459] {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
}
.envio-sms-ready[data-v-52eb9459] {
  margin: 0;
  color: var(--ink-soft);
  font-size: 0.86rem;
  line-height: 1.35;
}
.envio-sms-ready--faltan[data-v-52eb9459] {
  color: var(--emergencia);
  font-weight: 600;
}
.envio-sms-footer-alerts[data-v-52eb9459] {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  top: 50%;
  display: flex;
  align-items: center;
  margin: 0;
  overflow: visible;
  pointer-events: none;
  transform: translateY(-50%);
}
.envio-sms-footer-alerts[data-v-52eb9459] .alert {
  width: 100%;
  height: auto;
  min-height: 2.6rem;
  margin: 0;
  padding: 0.55rem 0.75rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  line-height: 1.25;
  pointer-events: auto;
}
.envio-sms-footer-alerts[data-v-52eb9459] .alert > * {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.envio-sms-footer-alerts[data-v-52eb9459] .btn-close {
  flex-shrink: 0;
  align-self: center;
  background-size: 0.8em;
  opacity: 0.7;
  box-shadow: none;
}
.envio-sms-footer-actions[data-v-52eb9459] {
  display: flex;
  flex: 0 0 auto;
  gap: 0.5rem;
  justify-content: flex-end;
}
.envio-sms-footer-actions[data-v-52eb9459] .btn:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}
@media (max-width: 760px) {
.envio-sms-sheet[data-v-52eb9459] {
    padding: 0.85rem 0.8rem 0.75rem;
}
.envio-sms-cabecera[data-v-52eb9459] {
    flex-direction: column;
}
.envio-sms-origen[data-v-52eb9459] {
    flex: 0 0 auto;
    width: 100%;
}
.envio-sms-mando[data-v-52eb9459],
  .envio-sms-datos[data-v-52eb9459],
  .envio-sms-secuencia-grid[data-v-52eb9459],
  .envio-sms-id-row[data-v-52eb9459],
  .envio-sms-grid-3[data-v-52eb9459],
  .envio-sms-grid-4[data-v-52eb9459] {
    grid-template-columns: 1fr;
}
.envio-sms-placa[data-v-52eb9459] {
    min-height: 0;
}
.envio-sms-field-fecha[data-v-52eb9459],
  .envio-sms-field-hora[data-v-52eb9459],
  .envio-sms-gestor[data-v-52eb9459] {
    flex: 1 1 100%;
}
.envio-sms-field-fecha[data-v-52eb9459] .form-control,
  .envio-sms-field-hora[data-v-52eb9459] .form-control {
    width: 100%;
}
.envio-sms-footer[data-v-52eb9459] {
    flex-direction: column;
    align-items: stretch;
}
.envio-sms-footer-actions[data-v-52eb9459] .btn {
    flex: 1 1 auto;
}
}
@media (prefers-reduced-motion: reduce) {
.envio-sms-placa[data-v-52eb9459],
  .envio-sms-chip[data-v-52eb9459] {
    transition: none;
}
}
`, "",{"version":3,"sources":["webpack://./src/app/components/EnvioSms.vue"],"names":[],"mappings":";AA+wBA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;AAC7B;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;AAEA;EACE,qBAAqB;AACvB;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,iBAAiB;EACjB,gBAAgB;AAClB;AAEA;;EAEE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;AAEA;EACE,yEAAyE;AAC3E;AAEA;EACE,gDAAgD;AAClD;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,0BAA0B;AAC5B;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AAEA;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,MAAM;EACN,uCAAuC;EACvC,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kFAAkF;AACpF;AAEA;EACE,qCAAqC;AACvC;AAEA;;EAEE,gCAAgC;AAClC;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,mBAAmB;AACrB;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;AAC7B;AAEA;EACE,gCAAgC;AAClC;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;AACpB;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,uCAAuC;EACvC,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kFAAkF;AACpF;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,WAAW;AACb;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AAEA;;;EAGE,aAAa;EACb,iBAAiB;AACnB;AAEA;EACE,0DAA0D;AAC5D;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;AAEA;EACE,6DAA6D;AAC/D;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,mBAAmB;AACrB;AAEA;;EAEE,cAAc;AAChB;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AAEA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,uCAAuC;AACzC;AAEA;EACE,aAAa;AACf;AAEA;;EAEE,wBAAwB;EACxB,4CAA4C;AAC9C;AAEA;;;EAGE,+BAA+B;EAC/B,yBAAyB;AAC3B;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,cAAc;EACd,WAAW;EACX,yBAAyB;AAC3B;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AAEA;AACE;IACE,+BAA+B;AACjC;AAEA;IACE,sBAAsB;AACxB;AAEA;IACE,cAAc;IACd,WAAW;AACb;AAEA;;;;;;IAME,0BAA0B;AAC5B;AAEA;IACE,aAAa;AACf;AAEA;;;IAGE,cAAc;AAChB;AAEA;;IAEE,WAAW;AACb;AAEA;IACE,sBAAsB;IACtB,oBAAoB;AACtB;AAEA;IACE,cAAc;AAChB;AACF;AAEA;AACE;;IAEE,gBAAgB;AAClB;AACF","sourcesContent":["\n.envio-sms-page {\n  --ink: #1b2740;\n  --ink-soft: #5c6b86;\n  --line: #d5deea;\n  --sheet: #f3f6fa;\n  --field: #8b97ab;\n  --binding: #ff7900;\n  --seguimiento: #c2410c;\n  --cierre: #0f6e6a;\n  --emergencia: #9b1c3c;\n  margin-top: -0.75rem;\n  padding-top: 0.65rem;\n  background: #fff;\n  color: var(--ink);\n}\n\n.envio-sms-formulario {\n  max-width: none;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.envio-sms-sheet {\n  background: var(--sheet);\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  padding: 0.8rem 1rem 0.7rem;\n}\n\n.envio-sms-cabecera {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem 1.5rem;\n  margin-bottom: 0.6rem;\n}\n\n.envio-sms-origen {\n  flex: 0 1 16rem;\n  width: 16rem;\n  margin-bottom: 0;\n}\n\n.envio-sms-clave {\n  margin-bottom: 0.6rem;\n}\n\n.envio-sms-mando {\n  display: grid;\n  grid-template-columns: minmax(12rem, 0.9fr) minmax(18rem, 1.35fr) auto;\n  gap: 0.55rem 1rem;\n  align-items: end;\n}\n\n.envio-sms-datos,\n.envio-sms-grid-4 {\n  display: grid;\n  gap: 0.55rem 0.85rem;\n  margin-top: 0.65rem;\n}\n\n.envio-sms-datos {\n  grid-template-columns: minmax(0, 1.45fr) minmax(0, 1.25fr) 11.5rem 9.5rem;\n}\n\n.envio-sms-grid-4 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.envio-sms-acciones {\n  grid-column: 1 / -1;\n}\n\n.envio-sms-formulario #seccionCabecera p {\n  text-align: left;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.envio-sms-title {\n  display: block;\n  font-size: 1.45rem;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  color: var(--ink);\n}\n\n.envio-sms-title::after {\n  content: \"\";\n  display: block;\n  width: 2.25rem;\n  height: 3px;\n  margin-top: 0.35rem;\n  background: var(--binding);\n}\n\n.envio-sms-lead {\n  margin-top: 0.55rem;\n  color: var(--ink-soft);\n  font-size: 0.95rem;\n}\n\n.envio-sms-secuencia {\n  border: 0;\n  margin: 0;\n  padding: 0;\n  min-inline-size: 0;\n}\n\n.envio-sms-bloque-titulo {\n  margin: 0 0 0.7rem;\n  padding: 0;\n  float: none;\n  width: auto;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n  color: var(--ink);\n}\n\n.envio-sms-bloque {\n  margin-top: 1.45rem;\n}\n\n.envio-sms-bloque-primero {\n  margin-top: 0.15rem;\n}\n\n.envio-sms-fin {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.45rem 1rem;\n  margin-top: 0.6rem;\n}\n\n.envio-sms-bloque-lead {\n  margin: -0.35rem 0 0.8rem;\n  color: var(--ink-soft);\n  font-size: 0.84rem;\n  line-height: 1.4;\n}\n\n.envio-sms-secuencia-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.4rem;\n}\n\n.envio-sms-placa {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0;\n  min-height: calc(1.5em + 0.56rem + 2px);\n  margin: 0;\n  padding: 0 0.65rem;\n  border: 1px solid var(--line);\n  border-left: 4px solid var(--ink);\n  border-radius: 6px;\n  background: #fff;\n  color: var(--ink);\n  cursor: pointer;\n  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;\n}\n\n.envio-sms-placa--seguimiento {\n  border-left-color: var(--seguimiento);\n}\n\n.envio-sms-placa--cierre,\n.envio-sms-placa--final {\n  border-left-color: var(--cierre);\n}\n\n.envio-sms-placa input {\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.envio-sms-placa-name {\n  font-size: 0.92rem;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.envio-sms-placa-hint {\n  color: var(--ink-soft);\n  font-size: 0.82rem;\n  line-height: 1.3;\n}\n\n.envio-sms-placa:hover:not(.is-selected, .is-disabled) {\n  background: #f4f7fb;\n}\n\n.envio-sms-placa.is-disabled,\n.envio-sms-placa.is-disabled:hover {\n  background: #f3f5f8;\n  color: var(--ink-soft);\n  cursor: not-allowed;\n}\n\n.envio-sms-placa.is-disabled input {\n  cursor: not-allowed;\n}\n\n.envio-sms-apertura-nota {\n  margin-top: 0.55rem;\n}\n\n.envio-sms-placa:focus-within {\n  outline: 2px solid var(--ink);\n  outline-offset: 2px;\n}\n\n.envio-sms-placa.is-selected {\n  background: var(--ink);\n  border-color: var(--ink);\n  color: #fff;\n}\n\n.envio-sms-placa--seguimiento.is-selected {\n  background: var(--seguimiento);\n  border-color: var(--seguimiento);\n}\n\n.envio-sms-placa--cierre.is-selected,\n.envio-sms-placa--final.is-selected {\n  background: var(--cierre);\n  border-color: var(--cierre);\n}\n\n.envio-sms-placa.is-selected .envio-sms-placa-hint {\n  color: rgba(255, 255, 255, 0.84);\n}\n\n.envio-sms-secuencia.is-invalid .envio-sms-placa:not(.is-selected) {\n  border-color: var(--emergencia);\n  background: #fde8ec;\n}\n\n.envio-sms-clasificacion {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.75rem 1.75rem;\n  margin-top: 0.9rem;\n}\n\n.envio-sms-estado {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.35;\n}\n\n.envio-sms-severidad {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.envio-sms-severidad-label {\n  flex: 1 0 100%;\n  margin: 0 0 0.3rem;\n  padding: 0;\n  float: none;\n  width: auto;\n  font-size: 0.82rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.envio-sms-chip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  margin: 0;\n  min-height: calc(1.5em + 0.56rem + 2px);\n  padding: 0 0.8rem;\n  border: 1px solid var(--field);\n  border-radius: 4px;\n  background: #fff;\n  color: var(--ink);\n  font-size: 0.88rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;\n}\n\n.envio-sms-chip input {\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.envio-sms-chip:focus-within {\n  outline: 2px solid var(--ink);\n  outline-offset: 2px;\n}\n\n.envio-sms-chip.is-selected {\n  background: var(--ink);\n  border-color: var(--ink);\n  color: #fff;\n}\n\n.envio-sms-chip--emergencia.is-selected {\n  background: var(--emergencia);\n  border-color: var(--emergencia);\n}\n\n.envio-sms-chip:has(input.is-invalid):not(.is-selected) {\n  border-color: var(--emergencia);\n  background: #fde8ec;\n}\n\n.envio-sms-id-row,\n.envio-sms-grid-3,\n.envio-sms-destino {\n  display: grid;\n  gap: 0.75rem 1rem;\n}\n\n.envio-sms-id-row {\n  grid-template-columns: minmax(0, 1.15fr) minmax(0, 0.85fr);\n}\n\n.envio-sms-grid-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 0.65rem;\n}\n\n.envio-sms-destino {\n  grid-template-columns: repeat(auto-fit, minmax(16rem, 22rem));\n}\n\n.envio-sms-cuando,\n.envio-sms-fin-cuando {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.75rem 1rem;\n}\n\n.envio-sms-cuando {\n  margin-top: 0.75rem;\n}\n\n.envio-sms-field-gap {\n  margin-top: 0.75rem;\n}\n\n.envio-sms-gestor {\n  flex: 1 1 16rem;\n  min-width: 12rem;\n}\n\n.envio-sms-field {\n  margin-bottom: 0;\n}\n\n.envio-sms-formulario :deep(.form-label) {\n  margin-bottom: 0.3rem;\n  color: var(--ink);\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.envio-sms-mark {\n  margin-left: 0.35rem;\n  color: var(--ink-soft);\n  font-size: 0.75rem;\n  font-weight: 400;\n}\n\n.envio-sms-req {\n  margin-left: 0.15rem;\n  color: var(--binding);\n  font-weight: 700;\n}\n\n.envio-sms-hint {\n  margin: 0.35rem 0 0;\n  color: var(--ink-soft);\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.envio-sms-fin-check {\n  margin-top: 0.1rem;\n}\n\n.envio-sms-fin-cuando {\n  margin-top: 0.75rem;\n}\n\n.envio-sms-field-fecha,\n.envio-sms-field-hora {\n  flex: 0 0 auto;\n}\n\n.envio-sms-field-fecha :deep(.form-control) {\n  width: 11.2rem;\n  max-width: 100%;\n}\n\n.envio-sms-field-hora :deep(.form-control) {\n  width: 8.2rem;\n  max-width: 100%;\n}\n\n.envio-sms-formulario :deep(.form-control),\n.envio-sms-formulario :deep(.form-select) {\n  border-color: var(--field);\n  border-radius: 4px;\n  color: var(--ink);\n  padding-top: 0.28rem;\n  padding-bottom: 0.28rem;\n  min-height: calc(1.5em + 0.56rem + 2px);\n}\n\n.envio-sms-formulario :deep(textarea.form-control) {\n  min-height: 0;\n}\n\n.envio-sms-formulario :deep(.form-control:focus),\n.envio-sms-formulario :deep(.form-select:focus) {\n  border-color: var(--ink);\n  box-shadow: 0 0 0 3px rgba(27, 39, 64, 0.14);\n}\n\n.envio-sms-formulario :deep(.form-control.is-invalid),\n.envio-sms-formulario :deep(.form-select.is-invalid),\n.envio-sms-formulario :deep(textarea.is-invalid) {\n  border-color: var(--emergencia);\n  background-color: #fde8ec;\n}\n\n.envio-sms-resizable {\n  resize: vertical;\n  overflow-y: auto;\n}\n\n.envio-sms-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 0.7rem;\n  padding-top: 0.6rem;\n  border-top: 1px solid var(--line);\n}\n\n.envio-sms-footer-status {\n  position: relative;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.envio-sms-ready {\n  margin: 0;\n  color: var(--ink-soft);\n  font-size: 0.86rem;\n  line-height: 1.35;\n}\n\n.envio-sms-ready--faltan {\n  color: var(--emergencia);\n  font-weight: 600;\n}\n\n.envio-sms-footer-alerts {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  top: 50%;\n  display: flex;\n  align-items: center;\n  margin: 0;\n  overflow: visible;\n  pointer-events: none;\n  transform: translateY(-50%);\n}\n\n.envio-sms-footer-alerts :deep(.alert) {\n  width: 100%;\n  height: auto;\n  min-height: 2.6rem;\n  margin: 0;\n  padding: 0.55rem 0.75rem;\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  line-height: 1.25;\n  pointer-events: auto;\n}\n\n.envio-sms-footer-alerts :deep(.alert > *) {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.envio-sms-footer-alerts :deep(.btn-close) {\n  flex-shrink: 0;\n  align-self: center;\n  background-size: 0.8em;\n  opacity: 0.7;\n  box-shadow: none;\n}\n\n.envio-sms-footer-actions {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 0.5rem;\n  justify-content: flex-end;\n}\n\n.envio-sms-footer-actions :deep(.btn:focus-visible) {\n  outline: 2px solid var(--ink);\n  outline-offset: 2px;\n}\n\n@media (max-width: 760px) {\n  .envio-sms-sheet {\n    padding: 0.85rem 0.8rem 0.75rem;\n  }\n\n  .envio-sms-cabecera {\n    flex-direction: column;\n  }\n\n  .envio-sms-origen {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .envio-sms-mando,\n  .envio-sms-datos,\n  .envio-sms-secuencia-grid,\n  .envio-sms-id-row,\n  .envio-sms-grid-3,\n  .envio-sms-grid-4 {\n    grid-template-columns: 1fr;\n  }\n\n  .envio-sms-placa {\n    min-height: 0;\n  }\n\n  .envio-sms-field-fecha,\n  .envio-sms-field-hora,\n  .envio-sms-gestor {\n    flex: 1 1 100%;\n  }\n\n  .envio-sms-field-fecha :deep(.form-control),\n  .envio-sms-field-hora :deep(.form-control) {\n    width: 100%;\n  }\n\n  .envio-sms-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .envio-sms-footer-actions :deep(.btn) {\n    flex: 1 1 auto;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .envio-sms-placa,\n  .envio-sms-chip {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
